import { useMemo } from 'react';
import SVG from 'react-inlinesvg';
import { POI_DETAILS_DEFAULT, POI_DETAILS_FALLBACK } from '@/constants';
import { upperSnakeCase } from '@/utils';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { SvgIcon } from '@mui/material';

export const PoiIcon = ({ name }: { name: string }) => {
  const poiTemplateIcons = useAtomValue(state.poiTemplateIcons);
  const icon = useMemo(() => {
    const fetchedIcon = poiTemplateIcons.find(
      (poiTemplate) => upperSnakeCase(poiTemplate.name) === upperSnakeCase(name)
    )?.icon;
    if (fetchedIcon) {
      return (
        <SvgIcon>
          <SVG src={fetchedIcon} data-testid={upperSnakeCase(name)} />
        </SvgIcon>
      );
    }

    return (
      POI_DETAILS_FALLBACK.find(
        (fallbackDetail) => upperSnakeCase(fallbackDetail.name) === upperSnakeCase(name)
      )?.icon ?? POI_DETAILS_DEFAULT.icon
    );
  }, [name, poiTemplateIcons]);
  return icon;
};
